// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import ElementExportPopupBUtton from './ElementExportPopupButton';

// Constants
import { MIME_TYPES } from '../../../common/media/mimeConstants';
import { BOARD_EXPORT_FORMATS, BOARD_EXPORT_QUALITY } from '../../../common/export/exportConstants';

// Styles
import './ExportPopup.scss';

const ExportPopupForDocumentModal = ({ elementId }) => (
    <div className="ExportPopup">
        <div className="export-section">
            <div className="export-options">
                <h3>Export as...</h3>
                <ElementExportPopupBUtton
                    elementId={elementId}
                    fileType={MIME_TYPES.PDF}
                    format={BOARD_EXPORT_FORMATS.linear}
                    quality={BOARD_EXPORT_QUALITY.high}
                >
                    PDF
                </ElementExportPopupBUtton>
                <ElementExportPopupBUtton
                    elementId={elementId}
                    fileType={MIME_TYPES.DOCX}
                    format={BOARD_EXPORT_FORMATS.linear}
                >
                    Word document
                </ElementExportPopupBUtton>
                <ElementExportPopupBUtton
                    elementId={elementId}
                    fileType={MIME_TYPES.MARKDOWN}
                    format={BOARD_EXPORT_FORMATS.linear}
                >
                    Markdown
                </ElementExportPopupBUtton>
                <ElementExportPopupBUtton
                    elementId={elementId}
                    fileType={MIME_TYPES.PLAIN_TEXT}
                    format={BOARD_EXPORT_FORMATS.linear}
                >
                    Plain text
                </ElementExportPopupBUtton>
            </div>
            <div className="export-illustration">
                <img
                    alt="export linear document image"
                    className="export-linear-document-image"
                    src={require('./export-linear-document.png')}
                />
            </div>
        </div>
    </div>
);

ExportPopupForDocumentModal.propTypes = {
    elementId: PropTypes.string.isRequired,
};

export default ExportPopupForDocumentModal;
